/*
 * piner header — .depth-list toggle (piner.css design system).
 * Click a [data-depth-toggle] trigger to toggle .is-active on its sibling
 * .depth-list; opening one closes the others; clicking outside (or the dim)
 * closes all. While a list is open the header gets .depth-open (shows the dim)
 * and --band-top / --band-bottom are set so the white bands grow to cover the
 * open menu. Self-contained: no imports, load with a plain deferred <script>.
 */
(function pinerHeaderDepthToggle() {
  function header() {
    return document.querySelector('.piner-header');
  }

  function updateBands() {
    var el = header();
    if (!el) return;

    var topBand = 0;
    var bottomBand = 0;
    var anyOpen = false;

    el.querySelectorAll('.depth-list.is-active').forEach(function (list) {
      anyOpen = true;
      var corner = list.closest('.piner-header__corner');
      var rect = list.getBoundingClientRect();

      if (corner && (corner.classList.contains('ph--tl') || corner.classList.contains('ph--tr'))) {
        // Top corners: band must reach from the viewport top to the list bottom.
        topBand = Math.max(topBand, rect.bottom);
      } else {
        // Bottom corners: band must reach from the list top to the viewport bottom.
        bottomBand = Math.max(bottomBand, window.innerHeight - rect.top);
      }
    });

    if (topBand > 0) el.style.setProperty('--band-top', Math.ceil(topBand) + 'px');
    else el.style.removeProperty('--band-top');

    if (bottomBand > 0) el.style.setProperty('--band-bottom', Math.ceil(bottomBand) + 'px');
    else el.style.removeProperty('--band-bottom');

    el.classList.toggle('depth-open', anyOpen);
  }

  function closeAll(except) {
    document.querySelectorAll('.piner-header .depth-list.is-active').forEach(function (list) {
      if (list === except) return;
      list.classList.remove('is-active');
      var trigger = list.parentElement.querySelector('[data-depth-toggle]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-depth-toggle]');

    if (trigger) {
      var list = trigger.parentElement.querySelector('.depth-list');
      if (!list) return;
      var isOpen = list.classList.toggle('is-active');
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      closeAll(list);
      updateBands();
      return;
    }

    // Outside click (incl. the dim, or a click on a dropdown link) closes all.
    if (!event.target.closest('.piner-header .depth-list')) {
      closeAll(null);
      updateBands();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeAll(null);
      updateBands();
    }
  });

  window.addEventListener('resize', updateBands);
})();
